export const UNKNOWN_ERROR_CODE = 13;

export interface UsableError {
  code: number;
  message: string;
  httpStatus?: number;
  responseData?: Record<string, unknown>;
}
